import UtilsHelper from "../helpers/utilsHelper.ts";

const PageNotFound = () => {
    UtilsHelper.changeWindowDocumentTitle("Nie znaleziono strony");
    return (
        <div className="container">
            <div className="px-40 py-20 my-12">
                <div className="flex flex-col items-center">
                    <h1 className="font-bold text-[#008DD2] text-9xl">404</h1>

                    <h6 className="mb-2 text-2xl font-bold text-white text-center md:text-3xl">
                        Strony nie znaleziono
                    </h6>

                    <p className="mb-8 text-center text-[#9fa0a4] md:text-lg">
                        Nie możemy znaleźć szukanej strony.
                    </p>
                </div>
            </div>
        </div>
    );
}

export default PageNotFound;
